import { EMPTY, concat, of } from 'rxjs';
import { SlackFileDownloadUrl, SlackFileId, SlackFileMimetype, SlackFileName, SlackFilePermalink, SlackFileSize, SlackFileType } from '../value';
import { catchError, map, mergeMap, take, tap, toArray } from 'rxjs/operators';

import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { ISlackFileRepository } from '../repository';
import { SlackFile } from '../entity';
import { SlackFileDto } from '../dto';
import { SlackFileNotFoundError } from '../exception';
import { SlackMessageId } from '../../slack-message/value';

export class SlackFileDomainService {
  constructor(private readonly slackFileRepository: ISlackFileRepository) { }

  select(id: string) {
    return this.slackFileRepository.select(SlackFileId.create(id)).pipe(map(item => this.convertDto(item)));
  }

  selectAllFilesBySlackMessageId(slackMessageId: string) {
    return this.slackFileRepository
      .selectAll(new FirestoreQueryBuilder<SlackFile>().equalWhere('slackMessageId', slackMessageId))
      .pipe(map(item => this.convertDto(item)));
  }

  insertSlackFile(
    id: string,
    slackMessageId: string,
    name: string,
    mimetype: string,
    type: string,
    size: number,
    downloadUrl: string,
    permalink: string
  ) {
    return this.slackFileRepository.select(SlackFileId.create(id)).pipe(
      take(1),
      catchError(err => {
        if (err instanceof SlackFileNotFoundError) {
          const slackFile = new SlackFile(SlackFileId.create(id));
          slackFile.slackMessageId = SlackMessageId.create(slackMessageId);
          slackFile.name = SlackFileName.create(name);
          slackFile.mimetype = SlackFileMimetype.create(mimetype);
          slackFile.size = SlackFileSize.create(size);
          slackFile.type = SlackFileType.create(type);
          slackFile.downloadUrl = SlackFileDownloadUrl.create(downloadUrl);
          slackFile.permalink = SlackFilePermalink.create(permalink);
          return this.slackFileRepository.insert(slackFile).pipe(map(item => this.convertDto(item)));
        } else {
          return EMPTY;
        }
      })
    );
  }

  deleteAllBySlackMessageId(slackMessageId: string) {
    return concat(
      this.slackFileRepository.selectAll(new FirestoreQueryBuilder<SlackFile>().equalWhere('slackMessageId', slackMessageId)).pipe(
        mergeMap(item => this.slackFileRepository.delete(item.id)),
        toArray()
      ),
      of(null)
    );
  }

  private convertDto(slackFile: SlackFile): SlackFileDto {
    return SlackFile.allFields.reduce((p, key) => {
      if (slackFile[key] === undefined) {
        return p;
      }
      const value = slackFile[key] as { value: any };
      p[key] = value.value;
      return p;
    }, {} as SlackFileDto);
  }
}
